import { fetchGetPaymentMethod } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../../iwQueryClient/useStateKey';

export function useGetBankDetails() {
    const stateKey = useStateKey();

    const { data } = useQuery({
        queryKey: ['payment_method', stateKey],
        queryFn: () => fetchGetPaymentMethod({ stateKey }),
        select: (response) => {
            const fundingBankAccount = response.data?.find(
                (method) =>
                    method.payment_method_type === 'bank_account' &&
                    method.roles.funding === 'enabled'
            );

            if (!fundingBankAccount?.bank_details) return null;

            return {
                accountNumber: fundingBankAccount.bank_details.account_number,
                sortCode: fundingBankAccount.bank_details.sort_code
            };
        }
    });

    return { bankDetails: data ?? null };
}
